/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BeltCircumferenceRange { 
    type?: BeltCircumferenceRange.TypeEnum;
    min?: number;
    max?: number;
    confirmed?: boolean;
}
export namespace BeltCircumferenceRange {
    export const TypeEnum = {
        Predefined: 'predefined',
        Custom: 'custom'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


export type TypeEnum = typeof BeltCircumferenceRange.TypeEnum[keyof typeof BeltCircumferenceRange.TypeEnum];
